import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Panel } from "primeng/panel";

@Component({
  selector: "app-collapsible-panel",
  templateUrl: "./collapsible-panel.component.html",
  styleUrls: ["./collapsible-panel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsiblePanelComponent implements OnInit {
  @ViewChild("primePanel", { static: true }) primePanel: Panel;
  @Input() startCollapsed = false;
  @Output() expand = new EventEmitter<void>();
  @Output() collapse = new EventEmitter<void>();

  ngOnInit() {
    if (this.startCollapsed) {
      this.primePanel.collapse(new MouseEvent("click"));
    }
  }

  onAfterToggle(event: { collapsed: boolean }): void {
    if (event.collapsed) {
      this.collapse.emit();
    } else {
      this.expand.emit();
    }
  }

}
